// src/context/TabContext.tsx

import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';

type Document = {
  id: string;
  name: string;
  type: string;
  crtddt?: string;
  status?: string;
  // Add other properties you need for your document
};

type TabContextType = {
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
  selectedDoc: Document | null;
  setSelectedDoc: (doc: Document | null) => void;
  selectedId: number;
  setSelectedId: (id: number) => void;
  selectedDocType: string;
  setSelectedDocType: (docType: string) => void;
};

const TabContext = createContext<TabContextType | undefined>(undefined);

export const TabProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [selectedTab, setSelectedTab] = useState<string>('SOAP Notes');
  const [selectedDoc, setSelectedDoc] = useState<Document | null>(null);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedDocType, setSelectedDocType] = useState('custom');

  return (
    <TabContext.Provider
      value={{
        selectedTab,
        setSelectedTab,
        selectedDoc,
        setSelectedDoc,
        selectedId,
        setSelectedId,
        selectedDocType,
        setSelectedDocType,
      }}
    >
      {children}
    </TabContext.Provider>
  );
};

export const useTabContext = (): TabContextType => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTabContext must be used within a TabProvider');
  }
  return context;
};
